import { Sheet, SheetContent, SheetHeader, SheetOverlay } from "@/components/rac/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect, useState } from "react";

function SlotSheetOverLay({
	isOpen,
	children,
	onClose,
	header,
}: {
	isOpen: boolean;
	children: React.ReactNode;
	onClose: Function;
	header?: string;
}) {
	const isMobile = useIsMobile();
	// Use standard mobile breakpoint hook (Tailwind: <768px)
	const [internalOpen, setInternalOpen] = useState(false);

	// Sync internal state with prop in useEffect to avoid render side-effects
	useEffect(() => {
		if (isOpen !== internalOpen) {
			setInternalOpen(isOpen);
		}
	}, [isOpen, internalOpen]);
	const sheetOverlayClass = `w-full  max-w-full w-[500px] px-0 ${isMobile ? "rounded-2xl max-h-[90dvh]" : ""}`;

	return (
		<Sheet
			isOpen={internalOpen}
			onOpenChange={open => {
				if (!open) onClose();
			}}
		>
			<SheetOverlay style={{ zIndex: 100000000 }}>
				<SheetContent side={"bottom"} className={sheetOverlayClass}>
					<SheetHeader>{header && <h2 className="text-xl font-semibold text-gray-900">{header}</h2>}</SheetHeader>
					{children}
				</SheetContent>
			</SheetOverlay>
		</Sheet>
	);
}

export default SlotSheetOverLay;
